import axios from "axios";

export const get_clusters = () => dispatch => {
    axios
        .get(
            "/api/clusters",
            "",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "SET_CLUSTERS",
                clusters: res.data.clusters
            });
        })
        .catch(err => {
            // toto sa nemoze stat
            dispatch({
                type: "SET_CLUSTERS",
                clusters: []
            });
        });
};

export const create_cluster = (title, description, col_1_name, col_2_name, col_3_name, col_1_language, col_2_language, col_3_language) => dispatch => {
    axios
        .post(
            "/api/clusters",
            JSON.stringify({
                title,
                description,
                col_1_name,
                col_2_name,
                col_3_name,
                col_1_language,
                col_2_language,
                col_3_language
            }),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "ADD_CLUSTER",
                cluster: res.data
            });
        })
        .catch(err => {
            dispatch({
                type: "SET_CLUSTER_ERROR",
                error: err.response.data.error
            });
        });
};

export const update_cluster = (id, title, description, col_1_name, col_2_name, col_3_name, col_1_language, col_2_language, col_3_language) => dispatch => {
    axios
        .patch(
            "/api/clusters/" + id,
            JSON.stringify({
                title,
                description,
                col_1_name,
                col_2_name,
                col_3_name,
                col_1_language,
                col_2_language,
                col_3_language
            }),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "UPDATE_CLUSTER",
                cluster: res.data
            });
        })
        .catch(err => {
            dispatch({
                type: "SET_CLUSTER_ERROR",
                error: err.response.data.error
            });
        });
};

export const remove_cluster = (id) => dispatch => {
    axios
        .delete(
            "/api/clusters/" + id,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "REMOVE_CLUSTER",
                cluster: res.data
            });
        })
        .catch(err => {
            dispatch({
                type: "SET_CLUSTER_ERROR",
                error: err.response.data.error
            });
        });
};

export const clear_cluster_error = () => dispatch => {
    dispatch({
        type: "CLEAR_CLUSTER_ERROR"
    });
};

export const create_cluster_share = (cluster_id, email) => dispatch => {
    axios
        .post(
            "/api/clusters/" + cluster_id + "/share",
            JSON.stringify({email}),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "ADD_CLUSTER_SHARE",
                cluster_id: cluster_id,
                share: res.data.shared_with_user
            });
            return true;
        })
        .catch(err => {
            dispatch({
                type: "SET_CLUSTER_SHARE_ERROR",
                error: err.response.data.error
            });
            return false;
        });
};

export const remove_cluster_share = (cluster_id, user_id) => dispatch => {
    axios
        .delete(
            "/api/clusters/" + cluster_id + "/share/" + user_id,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "REMOVE_CLUSTER_SHARE",
                cluster_id: cluster_id,
                user_id: user_id
            });
        })
        .catch(err => {
            dispatch({
                type: "SET_CLUSTER_SHARE_ERROR",
                error: err.response.data.error
            });
        });
};

export const clear_cluster_share_error = () => dispatch => {
    dispatch({
        type: "CLEAR_CLUSTER_SHARE_ERROR"
    });
};


export const get_cluster_data = (cluster_id) => dispatch => {
    axios
        .get(
            "/api/clusters/" + cluster_id + "/clusterRows",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "SET_CLUSTER_DATA",
                cluster_id: cluster_id,
                rows: res.data.rows
            });
        })
        .catch(err => {
            dispatch({
                type: "SET_CLUSTER_DATA_ERROR",
                error: err.response.data.error
            });
        });
};

export const change_cluster_data_row_order = (cluster_id, source, destination) => dispatch => {
    let modify = {
        row_number: destination.row_number
    };
    axios
        .patch(
            "/api/clusters/" + cluster_id + "/clusterRows/" + source.id,
            JSON.stringify(modify),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "SET_CLUSTER_DATA",
                cluster_id: cluster_id,
                rows: res.data.rows
            });
        })
        .catch(err => {
            dispatch({
                type: "SET_CLUSTER_DATA_ERROR",
                error: err.response.data
            });
        });
};

export const update_cluster_data_row_cell = (cluster_id, row_id, col, value) => dispatch => {
    let modify = {};
    modify["col_" + col + "_value"] = value;
    axios
        .patch(
            "/api/clusters/" + cluster_id + "/clusterRows/" + row_id,
            JSON.stringify(modify),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "UPDATE_CLUSTER_DATA_ROW",
                cluster_id: cluster_id,
                row: res.data
            });
        })
        .catch(err => {
            dispatch({
                type: "SET_CLUSTER_DATA_ERROR",
                error: err.response.data
            });
        });
};

export const add_cluster_data_row = (cluster_id, col_1_value, col_2_value, col_3_value, callback = () => {
}) => dispatch => {
    return axios
        .post(
            "/api/clusters/" + cluster_id + "/clusterRows",
            JSON.stringify({col_1_value, col_2_value, col_3_value}),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            callback(res.data);
            dispatch({
                type: "ADD_CLUSTER_DATA_ROW",
                cluster_id: cluster_id,
                row: res.data
            });
        });
    /*

        .catch(err => {
            dispatch({
                type: "SET_CLUSTER_DATA_ERROR",
                error: err.response.data
            });
        })
     */
};

export const remove_cluster_data_row = (cluster_id, row_id) => dispatch => {
    axios
        .delete(
            "/api/clusters/" + cluster_id + "/clusterRows/" + row_id,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "REMOVE_CLUSTER_DATA_ROW",
                cluster_id: cluster_id,
                row_id: row_id
            });
        })
        .catch(err => {
            dispatch({
                type: "SET_CLUSTER_DATA_ERROR",
                error: err.response.data
            });
        });
};


export const cancel_share = (cluster_id, block) => dispatch => {
    return axios
        .post(
            "/api/clusters/" + cluster_id + "/cancel-share",
            JSON.stringify({block}),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
};


export const translate_cluster_cell = (cluster_id, source_col_number, target_col_number, text) => dispatch => {
    return axios
        .post(
            "/api/clusters/" + cluster_id + "/translate",
            {source_col_number, target_col_number, text},
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
};

export const import_cluster = (cluster_id, first_line_header, append) => dispatch => {
    return axios
        .post(
            "/api/clusters/" + cluster_id + "/start-import",
            {first_line_header, append},
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
};
export const generate_ai_import = ({
                                       cluster_id,
                                       cluster_title,
                                       topic,
                                       word_count,
                                       col_1_language,
                                       col_2_language,
                                       col_3_language
                                   }) => dispatch => {
    return axios
        .post(
            "/api/ai/import",
            {
                cluster_id, cluster_title, topic, word_count, col_1_language, col_2_language, col_3_language
            },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
};

export const cancel_ai_import = () => dispatch => {
    return axios
        .delete(
            "/api/ai/import",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
};

export const start_ai_import = () => dispatch => {
    return axios
        .post(
            "/api/ai/start-import",
            {},
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
};

export const listen = (cluster_id, row_id, col_number, cancelToken) => dispatch => {
    return axios
        .post(
            "/api/listen/" + cluster_id,
            {row_id, col_number},
            {
                headers: {
                    "Content-Type": "application/json"
                },
                responseType: 'blob',
                cancelToken: cancelToken.token
            }
        );
};